// Author YuJiaBei
// Date 2020-07-23 17:20:18

import * as model from "@/model/em/workflow/EmActProcessDefinitionRegisterModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
var filter = Object.assign({}, paginationFilter, model.filter)
return filter;
}

export default newEntityStoreHelper(() => new model.EmActProcessDefinitionRegister(),newFilter)
.withStates({
baseModuleUrl: process.env.VUE_APP_EM_WORKFLOW_URL,
})
.buildStore()
